import {flow, getEnv, getType, resolveIdentifier, types} from 'mobx-state-tree';
import {ExtendedDataSelectState} from "../../extendedData/ExtendedDataSelectState";
import {CodeParamsTypeSelectState} from "../parameters/codeType/CodeParamsTypeSelectState";
import {GS1ParamsTypeSelectState} from "../parameters/gs1Type/GS1ParamsTypeSelectState";
import React from "react";

export const UtmParameterSelectState = types.model('UtmParameterSelectState',{
  selectStateUuid: types.identifier,
  codeParamsTypeSelectState: types.maybe(CodeParamsTypeSelectState),
  gs1ParamsTypeSelectState: types.maybe(GS1ParamsTypeSelectState),
  UtmExtendedDataSelectStore: types.maybe(types.late(() => types.reference(ExtendedDataSelectState))),
}).volatile((self)=>({
  notifySelect: types.str,
})).actions((self) => ({
  search(txt){
    //self.groupOptions = self.groupStore.searchFor(txt)
    //self.groupStore.groups
  },

  setCodeParamsTypeSelectState(codeParamsStore) {
    self.codeParamsTypeSelectState = CodeParamsTypeSelectState.create({
      selectStateUuid: "codeParamsTypeSelectState",
      store: codeParamsStore
    });
  },
  setGS1ParamsTypeSelectState(gs1ParamsStore) {
    self.gs1ParamsTypeSelectState = GS1ParamsTypeSelectState.create({
      selectStateUuid: "gs1ParamsTypeSelectState",
      store: gs1ParamsStore
    });
  },
  setUtmExtedDataSelectState(extendedDataSelectStore) {
    self.UtmExtendedDataSelectStore = extendedDataSelectStore
  },
  setConsumer(f){
    self.notifySelect = f
  },
  select(utm) {

  },
  afterCreate() {
    console.log("Instantiated " + getType(self).name)
    self.notifySelect = (data) => { //TODO
      console.log("placeholder notifySelect")
    }
  },
  fetchAllParameters: flow(function* f() {
    const manager = getEnv(self).parametersManager
    const resp = yield manager.fetchAll();
    if (resp?.results) {
      self.mapParametersToSelectState(resp?.results)
    }
  }),
  mapParametersToSelectState(params) {
    params.forEach(p => {
      switch (p?.paramType) {
        case "codeParams":
          self.codeParamsTypeSelectState.store?.setList(p?.items)
          break;
        case "gs1Params":
          self.gs1ParamsTypeSelectState.store?.setList(p?.items);
        default:
          break;
      }
    })
  },
})).views( (self) => ({
  optionValues() {
    const codeTypeParams = self.codeParamsTypeSelectState?.options() || [];
    const gs1TypeParams = self.gs1ParamsTypeSelectState?.options() || [];
    const extendedDataParams = self.UtmExtendedDataSelectStore.optionValues() || []

    const codeParamOptions = codeTypeParams.slice()
      .sort((a, b) => a?.label?.localeCompare(b?.label))
      .flatMap( (code) => {
        return {
          label: code.label,
          value: code.uuid,
          type: "code"
        }
      });

    const gs1ParamOptions = gs1TypeParams.slice()
      .sort((a, b) => a?.label?.localeCompare(b?.label))
      .flatMap( (gs1) => {
        return {
          label: gs1.label,
          value:  gs1.uuid,
          type: "gs1"
        }
      });

    const edParamOptions = extendedDataParams.slice()
      .sort((a, b) => a?.label?.localeCompare(b?.label))
      .flatMap( (ed) => {
        return {
          label: ed.label,
          value: ed.uuid,
          type: "ed"
        }
      });

    const options = [
      {
        label: "CODE",
        options: codeParamOptions
      },
      {
        label: "GS1",
        options: gs1ParamOptions
      },
      {
        label: "Extended Data",
        options: edParamOptions
      },

      ]
    return options;
  },
}))


